import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Shared/Button";

const Project = ({ project }) => {
  const navigate = useNavigate();
  const { id, image, name, point1, point2, point3 } = project;

  return (
    <div className="font-Poppins">
      <div className="card max-w-xs h-[500px] bg-base-100 shadow-xl rounded-md">
        <figure>
          <img src={image} alt="Shoes" />
        </figure>
        <div className="card-body">
          <h2 className="text-xl font-BebasNeue">{name}</h2>
          <hr className="border-b-2 border-t-0 mb-4 border-neutral" />
          <ul className="list-disc text-sm leading-6">
            <li>{point1}</li>
            <li>{point2}</li>
            <li>{point3}</li>
          </ul>
          <div className="card-actions justify-end">
            <div onClick={() => navigate(`/project/${id}`)}>
              <Button>Details</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
